import { makeStyles, Theme } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles((theme: Theme) => ({
  title: (props: { isMobile: boolean }) => {
    return {
      marginTop: '30px',
      color: '#000000',
      fontWeight: 'bold',
      fontSize: props.isMobile ? '25px' : '33px',
      textAlign: 'center',
    }
  },
  subtitleWrapper: (props: { baseColors: BaseColors }) => {
    return {
      margin: '0 30px',
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: props.baseColors.primary,
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: props.baseColors.primaryLighter,
      },
      scrollbarWidth: 'thin',
      scrollbarColor: `${props.baseColors.primary} ${props.baseColors.primaryLighter}`,
    }
  },
  subtitle: {
    paddingTop: '15px',
    color: '#000000',
    fontSize: '18px',
    textAlign: 'center',
    whiteSpace: 'pre-line',
  },
  textButton: (props: { isMobile: boolean; baseColors: BaseColors }) => {
    return {
      color: props.baseColors.primary,
      fontSize: '23px',
      textAlign: 'center',
      '&:active': {
        color: 'white',
      },
    }
  },
  button: (props: { isMobile: boolean; baseColors: BaseColors }) => {
    return {
      border: `1px solid ${props.baseColors.primary}`,
      '&:hover': {
        boxShadow: 'none',
        background: props.baseColors.primaryLighter,
        color: 'white',
        border: `1px solid ${props.baseColors.primary}`,
      },
      '&:active': {
        boxShadow: 'none',
        background: props.baseColors.secondary,
        color: 'white',
        '& label': {
          color: 'white',
          border: `1px solid ${props.baseColors.secondary}`,
        },
      },
    }
  },
}))

export default buildStyles
